import { render, staticRenderFns } from "./tab-select.vue?vue&type=template&id=61a67c48"
import script from "./tab-select.vue?vue&type=script&lang=js"
export * from "./tab-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports